import { PromotionsApi } from '../clients';

export const createPromotion = async (input) =>
  PromotionsApi.createPromotion(input);
